import lodash from 'lodash';
import { takeEvery, call, put } from 'redux-saga/effects';
import { getLeadProfileHistory } from '../../requests/get_lead_profile_request';
import { checkLeadTypeUpdate, isBikeManagementUpdate } from '../../../utils/leadType';

function* getLeadHistory({ leadId }) {
    yield put({
        type: 'SET_LEAD_HISTORY_DATA',
        payload: {
            data: [],
            error: null,
            isLoading: true,
            isLeadTypeUpdate: false,
        },
    });

    const res = yield call(getLeadProfileHistory, leadId);

    let history = [];

    if (res.result) {
        const bikeHistory = lodash.get(res.options, 'ref_bike_lead.history') || [];
        history = history.concat(res.options.history, bikeHistory).sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
    }

    const bikeManagementUpdateItem = history.findLast((item) => isBikeManagementUpdate(item.action));
    const isLeadTypeUpdate = bikeManagementUpdateItem ? checkLeadTypeUpdate(bikeManagementUpdateItem.action) : false;

    yield put({
        type: 'SET_LEAD_HISTORY_DATA',
        payload: {
            data: history.reverse(),
            error: res.error,
            isLoading: false,
            isLeadTypeUpdate,
        },
    });
}

export default function* getLeadHistorySaga() {
    yield takeEvery('GET_LEAD_HISTORY_REQ', getLeadHistory);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_history.saga.js